export default "__VITE_ASSET__BRcj$llF__"